import { createReducer, createSelector } from 'redux-starter-kit';
import { putDamageTypeReferences } from './damageTypeActions';

/**
 * A selector for the damage types loaded in the domain state.
 * This is a list: [ damageType, damageType, ...]
 * @param {object} state The redux state of the application.
 * @returns An array of damage type objects.
 * @example const damageTypes = selectDamageTypes(state);
 */
export const selectDamageTypeReferences = createSelector(['via.domain.damageTypeReferences'], map => (map ? Object.values(map) : null));

/**
 * A selector for those damage type reference areas in the domain.
 * @param {state} state The redux state for the application.
 */
export const selectDamageTypeReferencesMap = state => state.via.domain.damageTypeReferences;

// A dict object with a property key of: modelTypeCode and a propertyValue of: modelType.
const initialDamageTypeReferencesState = {
  // damageAreaDescription: { /* damageAreas */ }
  // ...etc
};

/**
 * A reducer that handles action for the damageTypeReferences domain.
 */
const damageTypeReferencesReducer = createReducer(initialDamageTypeReferencesState, {
  // Inserts/Updates all the model types.
  [putDamageTypeReferences]: (state, action) => {
    const damageTypeReferences = action.payload;
    // Converts the array of damageTypeReferences into a dict object mapping the id to the model type.
    // { damageAreaDescription: { /* damageAreas */ }, damageAreaDescription: { /* damageAreas */ }, ...etc}
    return damageTypeReferences.reduce((newState, damageTypeRefs) => {
      newState[damageTypeRefs.damageAreaDescription] = damageTypeRefs; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...initialDamageTypeReferencesState });
  },
});


export default damageTypeReferencesReducer;